import axios from "axios";
import React, { useState } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";

const SignUp = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile_no: "",
    password: "",
    password_confirmation: "",
  });

  // Handle input changes
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };
const navigate = useNavigate();
  // Handle form submission
  const handleSubmit = (e) => {
    const id = toast.loading("Signing Up...");
    e.preventDefault();
    console.log("Form Data Submitted:", formData);


    let config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: 'https://admin.tulikaarts.in/api/register',
      data: formData
    };


    axios.request(config)
      .then((response) => {
        console.log(response.data);
        window.localStorage.setItem("token", response.data.access_token);
        toast.success("Signed Up Successfully", { id });
        navigate('/');
      })
      .catch((error) => {
        error?.response?.data?.errors?.map((error) => { 
          toast.error(error, { id });
        })
        
      });
  }

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h2>Sign Up</h2>
        <form onSubmit={handleSubmit}>
          <div style={styles.formGroup}>
            <label htmlFor="name">Full Name:</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              style={styles.input}
            />
          </div>
          <div style={styles.formGroup}>
            <label htmlFor="email">Email:</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              style={styles.input}
            />
          </div>
          <div style={styles.formGroup}>
            <label htmlFor="mobile_no">Number:</label>
            <input
              type="number"
              id="mobile_no"
              name="mobile_no"
              value={formData.mobile_no}
              onChange={handleChange}
              required
              style={styles.input}
            />
          </div>
          <div style={styles.formGroup}>
            <label htmlFor="password">Password:</label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
              style={styles.input}
            />
          </div>
          <div style={styles.formGroup}>
            <label htmlFor="password_confirmation">Confirm Password:</label>
            <input
              type="password"
              id="password_confirmation"
              name="password_confirmation"
              value={formData.password_confirmation}
              onChange={handleChange}
              required
              style={styles.input}
            />
          </div>
          <button type="submit" style={styles.button}>
            Sign Up
          </button>
        </form>
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#f4f4f4",
  },
  card: {
    background: "#fff",
    padding: "20px",
    borderRadius: "8px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    width: "450px",
    textAlign: "center",
    marginTop: "120px",
    marginBottom: "30px",
  },
  formGroup: {
    marginBottom: "10px",
    textAlign: "left",
  },
  input: {
    width: "100%",
    padding: "8px 10px",
    border: "1px solid #ccc",
    borderRadius: "4px",
  },
  button: {
    width: "100%",
    padding: "10px",
    border: "none",
    borderRadius: "4px",
    backgroundColor: "#cc9051",
    color: "white",
    fontSize: "18px",
    fontWeight: "500",
    cursor: "pointer",
  },
};

export default SignUp;
